/* ReventaZone v2 · animaciones e interacción */
(function () {
  if (window.__rzx) return; window.__rzx = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* 1 · Aparición al hacer scroll */
    var rv = document.querySelectorAll('.rzx [data-rv]');
    if (!hasIO || reduce) rv.forEach(function (el) { el.classList.add('in'); });
    else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      rv.forEach(function (el) { io.observe(el); });
    }

    /* 2 · Pestañas con indicador deslizante + seguimiento del scroll */
    document.querySelectorAll('.rzx-tabs').forEach(function (bar) {
      var inner = bar.querySelector('.rzx-tabs__in');
      var ind = bar.querySelector('.rzx-tabs__ind');
      var links = Array.prototype.slice.call(bar.querySelectorAll('a[href^="#"]'));
      var lock = false, lockT = null;
      function move(a) {
        links.forEach(function (l) { l.classList.toggle('is-on', l === a); });
        if (!a) return;
        ind.style.width = a.offsetWidth + 'px';
        ind.style.transform = 'translateX(' + a.offsetLeft + 'px)';
        if (inner.scrollWidth > inner.clientWidth) inner.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
      }
      move(links[0]);
      window.addEventListener('resize', function () { move(bar.querySelector('a.is-on') || links[0]); });
      links.forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var t = document.querySelector(a.getAttribute('href'));
          if (!t) return;
          ev.preventDefault();
          move(a); lock = true; clearTimeout(lockT); lockT = setTimeout(function () { lock = false; }, 900);
          t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      });
      if (hasIO) {
        var io2 = new IntersectionObserver(function (es) {
          if (lock) return;
          es.forEach(function (e) {
            if (e.isIntersecting) {
              var a = links.filter(function (l) { return l.getAttribute('href') === '#' + e.target.id; })[0];
              if (a) move(a);
            }
          });
        }, { rootMargin: '-35% 0px -55% 0px' });
        links.forEach(function (l) { var t = document.querySelector(l.getAttribute('href')); if (t) io2.observe(t); });
      }
    });

    /* 3 · Cuenta atrás de temporada (fechas reales, hora de Madrid) */
    document.querySelectorAll('[data-rzx-countdown]').forEach(function (box) {
      var events = [
        { name: 'Black Friday', at: '2026-11-27T00:00:00+01:00' },
        { name: 'Navidad', at: '2026-12-25T00:00:00+01:00' },
        { name: 'Reyes', at: '2027-01-06T00:00:00+01:00' }
      ];
      var label = box.querySelector('[data-cd-name]'), out = box.querySelector('[data-cd-time]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var now = Date.now(), ev = null;
        for (var i = 0; i < events.length; i++) { if (new Date(events[i].at).getTime() > now) { ev = events[i]; break; } }
        if (!ev) { box.hidden = true; return; }
        var s = Math.floor((new Date(ev.at).getTime() - now) / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        label.textContent = ev.name;
        out.innerHTML = '<span><b>' + d + '</b>d</span><span><b>' + pad(h) + '</b>h</span><span><b>' + pad(m) + '</b>m</span><span><b>' + pad(s) + '</b>s</span>';
      }
      tick(); setInterval(tick, 1000);
    });

    /* 4 · Caja que se abre (hero) */
    document.querySelectorAll('.rz3-scene').forEach(function (sc) {
      if (reduce) { sc.classList.add('cut', 'open', 'out'); return; }
      var timers = [];
      function at(ms, fn) { timers.push(setTimeout(fn, ms)); }
      function set(add, rm) { (rm || []).forEach(function (c) { sc.classList.remove(c); }); (add || []).forEach(function (c) { sc.classList.add(c); }); }
      function cycle() {
        timers.forEach(clearTimeout); timers = [];
        sc.className = 'rz3-scene';
        at(400, function () { set(['shake']); });
        at(1000, function () { set(['cutting'], ['shake']); });
        at(1500, function () { set(['cut']); });
        at(2000, function () { set(['open'], ['cutting']); });
        at(2250, function () { set(['out']); });
        at(10400, function () { set(['back'], ['out']); });
        at(11500, function () { set([], ['open']); });
        at(12200, function () { set([], ['cut', 'back']); });
        at(13100, cycle);
      }
      if (hasIO) { var st = false; new IntersectionObserver(function (es) { if (es[0].isIntersecting && !st) { st = true; cycle(); } }, { threshold: 0.2 }).observe(sc); }
      else cycle();
    });

    /* 5 · Historia "Cómo funciona" */
    document.querySelectorAll('.rz2').forEach(function (root) {
      var stage = root.querySelector('.rz2-stage');
      if (!stage) return;
      var scenes = root.querySelectorAll('.rz2-scene');
      var steps = root.querySelectorAll('.rz2-step');
      var cap = root.querySelector('.rz2-caption');
      var titles = ['Elige tu proveedor', 'Aprende con la guía', 'Haz fotos y publica', 'Repite y crece'];
      var dur = [4200, 4200, 4200, 6400];
      var cur = 0, timer = null, raf = null;
      function count(el) {
        cancelAnimationFrame(raf);
        var to = +el.getAttribute('data-count'), t0 = null, len = 2600;
        if (reduce) { el.textContent = to; return; }
        el.textContent = '0';
        function tk(t) { if (t0 === null) t0 = t; var p = Math.min(1, Math.max(0, (t - t0 - 300) / len)); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) raf = requestAnimationFrame(tk); }
        raf = requestAnimationFrame(tk);
      }
      function go(i) {
        cur = i;
        stage.setAttribute('data-s', i);
        scenes.forEach(function (s) { s.classList.remove('on'); });
        void stage.offsetWidth;
        scenes[i].classList.add('on');
        cap.innerHTML = '<b>0' + (i + 1) + '</b><span>' + titles[i] + '</span>';
        steps.forEach(function (st, k) { st.classList.toggle('done', k < i); st.classList.remove('cur'); st.style.setProperty('--d', dur[k] + 'ms'); });
        void stage.offsetWidth;
        steps[i].classList.add('cur');
        if (i === 3) count(scenes[3].querySelector('[data-count]'));
        clearTimeout(timer);
        if (!reduce) timer = setTimeout(function () { go((cur + 1) % scenes.length); }, dur[i]);
      }
      steps.forEach(function (st, k) { st.querySelector('button').addEventListener('click', function () { go(k); }); });
      if (hasIO) { var started = false; new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !started) { started = true; go(0); } }); }, { threshold: 0.3 }).observe(stage); }
      else go(0);
    });
  });
})();
